// extracted by mini-css-extract-plugin
export default {"setting--inverted":"Yg8Juco","dark-theme":"b0Ypcc7","skeleton-loader":"RhDuakc","gradient":"IO0Zgb_","skeleton-loader--pill":"JsYY_bo"};